import { render, staticRenderFns } from "./CommonRequestForm.vue?vue&type=template&id=69dc8736&scoped=true&"
import script from "./CommonRequestForm.vue?vue&type=script&lang=js&"
export * from "./CommonRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./CommonRequestForm.vue?vue&type=style&index=0&id=69dc8736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dc8736",
  null
  
)

export default component.exports